// Isolated clock component to prevent unnecessary re-renders
import { useEffect, useState } from 'react';
import { startOfDay } from 'date-fns';

export const useClock = () => {
  const [currentDate, setCurrentDate] = useState(() => startOfDay(new Date()));

  useEffect(() => {
    // Check every minute if the day has changed
    const interval = setInterval(() => {
      const now = new Date();
      const today = startOfDay(now);
      
      // Only update state if the DAY changed (not just the time)
      setCurrentDate(prev => {
        const prevDay = startOfDay(prev);
        if (prevDay.getTime() !== today.getTime()) {
          return today;
        }
        return prev; // Same day, don't update
      });
    }, 1000 * 60); // Check every minute
    
    return () => clearInterval(interval);
  }, []);

  return currentDate;
};
